import { menuItem } from "./interface";
const BasePath = "../../assets/images"
export const menus: Array<menuItem> = [
  { name: "2021病案年会", path: "/100", banner: BasePath + '100banner-new.jpg' },
  { name: "领导寄语", path: "/leader", banner: BasePath + 'leader.jpg' },
  { name: "百年历程", path: "/journey", banner: BasePath + 'journey.jpg' },
  { name: "百年名人堂", path: "/famous", banner: BasePath + 'famous.jpg' },
  { name: "科室管理案例展", path: "/case", banner: BasePath + 'case.jpg' },
  { name: "病案老物件", path: "/old", banner: BasePath + 'old.jpg' },
  { name: "病案新风采", path: "/grace", banner: BasePath + 'grace.jpg' },
  { name: "《中国病案》杂志20周年", path: "/20", banner: BasePath + 'magazine.jpg' }
];